import $ from 'jquery';
export default {
  name: 'pending-visites-medicales',
  components: {},
  props: [],
  data () {
    return {
      filter: "",
      fields: [
        { key: 'index', label: 'N°' },
        { key: 'annee', label: 'Année' },
        { key: 'date_debut', label: 'Debut' },
        { key: 'date_fin', label: 'Fin' },
        { key: 'societe', label: 'Societe' },
        'voir'
      ],
      
    }
  },
  computed: {
    user(){
      return this.$store.getters["authInfo"];
    },
    activeRole(){
      return this.$store.getters["activeRole"];
    },
    visites(){
      return this.$store.getters["pendingVisitesForTechLabo"];
    }

  },
  mounted () {

    if(this.activeRole.nom=='ROLE_INFIRMIER_MEDECINE_TRAVAIL'){
      this.$store.dispatch('getVisitesForInfirmier',this.user.user.id)
      //this.$store.dispatch('getPendingVisitesForTechLabo')
    } else {
      this.$store.dispatch('getPendingVisitesForTechLabo')
    }
    
    setTimeout(() => {
        $('.shw').fadeIn()
    }, 500);
    $("tr:eq(2)").hide()
  },
  updated(){
     $("tr:eq(2)").hide()
  },
  methods: {

  }
}


